/**
* @Description: 单词量测试学生信息页
* @author wangShu
* @date 2020-05-22
*/
<template>
    <div class="content-box">
        <div class="info-title">
            <img :src="GLOBAL.Images.icon_title_report" alt="">
            学员信息
        </div>
        <div class="user-info">
            <img :src="GLOBAL.Images.avatar" alt="" class="img-box">
            <div class="right-info">
                <div class="name">{{userSource.realname}}</div>
                <div>账户：{{userSource.emp_no}}</div>
                <div>测试时间：{{dataSource.test_time}}</div>
            </div>
        </div>
        <div class="info-title">
            <img :src="GLOBAL.Images.icon_title_report" alt="">
            测试信息
        </div>
        <div class="info-list">
            <div>
                <div>测试类型：</div>
                <div>{{dataSource.edition}}({{dataSource.count}}题)</div>
            </div>
            <div>
                <div>得分：</div>
                <div>{{point}} 分</div>
            </div>
            <div>
                <div>答对：</div>
                <div>{{dataSource.complete}} 题</div>
            </div>
            <div>
                <div>答错：</div>
                <div>{{dataSource.un_complete}} 题</div>
            </div>
            <div>
                <div>用时：</div>
                <div>{{timeText}}</div>
            </div>
            <div>
                <div>获得能量石数：</div>
                <div>{{dataSource.power}}个</div>
            </div>
            <div>
                <div>全国排名：</div>
                <div>{{dataSource.level}}名</div>
            </div>
            <div>
                <div>掌握学段：</div>
                <div>{{dataSource.complete_rate}}%</div>
            </div>
        </div>
        <div class="test-explain">
            <div class="title">单词量测试结果</div>
            <div class="p" v-html="dataSource.word_test_explain"></div>
            <div class="guid-btn">
                <el-button type="success" size="mini" @click="goGuidPage">查看单词学习指导方案</el-button>
            </div>
        </div>
        <div class="foot-btn">
            <el-button type="danger" @click="close">退出测试</el-button>
        </div>

        <div class="grade-box">
            <el-dialog
                    title="选择年级"
                    :visible.sync="centerDialogVisible"
                    width="30%"
                    center>
                <el-select v-model="gradeId" placeholder="请选择">
                    <el-option
                            v-for="item in dataSource.grade"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="getFangAn">确 定</el-button>
              </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import Lockr from 'lockr'
    import {userInfo} from "@/api/user";

    export default {
        name: "report",
        props: {
            dataSource: {}
        },
        data() {
            return {
                userSource: {},
                centerDialogVisible: false,
                gradeId: '',
            };
        },
        computed: {
            timeText() {
                return this.formatTimerHMS(this.dataSource.use_time)
            },
            point() {
                return parseInt(100 * this.dataSource.complete / this.dataSource.count)
            }
        },
        methods: {
            //获取个人信息
            async getUserInfo() {
                let params = {
                    token: Lockr.get('token'),
                }
                let result = await userInfo(params);
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.userSource = result.data
                } else {
                    this.$alert(result.msg, '温馨提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                    });
                }
            },
            formatBit(val) {
                val = +val
                return val > 9 ? val : '0' + val
            },
            // 秒转时分秒
            formatTimerHMS(time) {
                let min = Math.floor(time % 3600)
                let val = this.formatBit(Math.floor(time / 3600)) + '时' + this.formatBit(Math.floor(min / 60)) + '分' + this.formatBit(time % 60) + '秒'
                return val
            },
            goGuidPage() {
                if (this.dataSource.select_grade == 1) {
                    this.centerDialogVisible = true
                } else {
                    this.close()
                window.location.href = '/#/wordsGuide?complete_rate=' + this.dataSource.complete_rate + '&level=' + this.dataSource.level + '&grade_id=' + this.gradeId + '&phrases_type=' + this.dataSource.phrases_type + '&class_id=' + this.dataSource.class_id
                }
            },
            getFangAn() {
                this.centerDialogVisible = false
                this.close()
                window.location.href = '/#/wordsGuide?complete_rate=' + this.dataSource.complete_rate + '&level=' + this.dataSource.level + '&grade_id=' + this.gradeId + '&phrases_type=' + this.dataSource.phrases_type + '&class_id=' + this.dataSource.class_id
            },
            // 关闭弹窗
            close() {
                this.$parent.close();
            }
        },
        created() {
            this.getUserInfo()
        }
    };
</script>

<style scoped lang='less'>
    .content-box {
        margin: 0 40px;
        padding-top: 20px;

        .info-title {
            display: flex;
            font-size: 18px;

            img {
                width: 20px;
                height: 20px;
                display: block;
                object-fit: contain;
            }
        }

        .user-info {
            display: flex;
            align-items: center;
            padding: 20px 0;
            border-bottom: 1px solid #dcdcdc;
            margin-bottom: 20px;

            .img-box {
                width: 80px;
                height: 80px;
                border-radius: 50%;
                margin-right: 30px;
            }

            .right-info {
                font-size: 16px;
                color: #666;

                > div {
                    margin: 10px 0;
                }

                .name {
                    color: #333;
                    font-size: 18px;
                }
            }
        }

        .info-list {
            border-bottom: 1px solid #dcdcdc;
            margin-bottom: 20px;
            padding-bottom: 10px;

            > div {
                display: flex;
                font-size: 16px;
                margin: 10px 0;
                padding: 0 20px;
                color: #333;
                font-weight: normal;
                > div:nth-of-type(1) {
                    width: 150px;
                    // text-align: right;
                    padding-right: 20px;
                }
            }
        }

        .test-explain {
            border: 1px solid #e3e3e3;
            padding: 20px;
            margin-top: 10px;

            .title {
                color: #2bc3b9;
                font-size: 16px;
                line-height: 1;
                border-left: 10px solid #2bc3b9;
                padding-left: 5px;
            }

            .p {
                color: #333;
                line-height: 1.8;
                font-size: 16px;
                margin-top: 10px;
                margin-left: 15px;
            }

            .guid-btn {
                text-align: right;
                margin-top: 20px;
            }
        }

        .foot-btn {
            margin: 20px 0;
            text-align: center;
        }
    }

    .grade-box {
        width: 400px;
        height: 200px;
    }
</style>